export const ADA_ENABLED_EVENT = 'ada:activated'
export const ADA_DISABLED_EVENT = 'ada:deactivated'
